import React from "react";
import Logo from "../assets/images/qualiphy-logo-hq.svg";
import { Link } from "react-router-dom";

const Modal = ({
  onContinueClick,
  isOpen,
  onClose,
  children,
  showLogo = true,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50 transition-opacity duration-300 opacity-100"
      style={{ transition: "opacity 0.3s ease-in-out" }}
    >
      <div className="bg-white p-6 md:mt-4 lg:mt-10 rounded-lg max-w-3xl w-full relative transition-transform transform scale-95">
        {showLogo && (
          <Link to="https://qualiphy.me/" target="_blank">
            <div className="">
              <img src={Logo} alt="Logo" className="h-12 w-100" />
            </div>
          </Link>
        )}
        <div className="pt-5">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
